// BookingLayout.jsx
import { useEffect , useState} from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate , useLocation } from 'react-router-dom';

const BookingLayout = ({ children }) => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const [isValid, setIsValid] = useState(false);
  

  const {
    BookingReducer,
    CommonReducer,
    FilterReducer
  } = useSelector((state) => state);

  const {
    sourcePoint,
    destinationPoint,
    sourceId,
    destinationId,
    sourcePointList,
    destinationPointList,
    rawDate,
    availableBusList,
    passengersCount,
    setBookingData
  } = BookingReducer;

  const {
    filterModal,
    reschedule,
    postBookingData,
    loadingState,
  } = CommonReducer;
  

  const {
    filter,
    boardingPoints,
    droppingPoints,
    amenities,
  } = FilterReducer;
  

  // ✅ Route-specific required fields
  const routeGuards = [
    {
      pathStart: '/booking' || "/booking/:id",
      required: [destinationId, sourceId, sourcePoint, destinationPoint, ]
    },
    {
      pathStart: '/booking-details',
      required: [setBookingData?.booking?.id],
    },
    // {
    //   pathStart: '/',
    //   required: [availableBusList, passengersCount],
    // },
  ];



  useEffect(() => {

    if (reschedule && pathname.startsWith('/booking')) {
    setIsValid(true);
    return;
    }

    const missingDataGuard = routeGuards.find(
      (guard) =>
        pathname.startsWith(guard.pathStart) &&
        guard.required.some((item) => item === null || item === undefined || item === '')
    );
    

    if (missingDataGuard) {
      navigate('/', { replace: true });
    }else {
      setIsValid(true); // ✅ allow rendering
    }
  }, [
    pathname,
    navigate,
    sourcePoint,
    destinationPoint,
    rawDate,
    availableBusList,
    passengersCount,
    postBookingData,
    reschedule
  ]);


  if (!isValid) return null;

  return (
    <div className="booking-layout">
      {children}
    </div>
  );
};

export default BookingLayout;
